import React from "react"
import { Link } from "gatsby"

import Layout from '../../components/layout'
import Seo from '../../components/seo'

import '../css/article.css'
//import images

import align from '../../images/devil-sea/devil_align.png'
import myster from '../../images/devil-sea/devil_mysterios.png'
import s1 from '../../images/devil-sea/devil_shape1.png'
import s2 from '../../images/devil-sea/devil_shape2.png'
import triangle from '../../images/devil-sea/devil_triangle.png'
import robot from '../../images/robot.png'
import bat from '../../images/bat.png'

const IndexPage = () => {
 
  return  (
<Layout>
    <Seo 
    title="Dragons living in the devil's sea- DEVILS'S SEA|SKTUTS"
    description=" Hope all of you have listened about the incidents at the bermuda triangle where many people have lost their lives there but there is another place on this earth where similar incidents happens 'The Devil's Triangle'"
    keywords="devil sea,devil's sea,sea devil swimming,kill devil hills sea ranch resort,devil's ridge sea of thieves,sea devils 1953,devil's island sea caves,sea devil short story,sea devil sailboat,sea devil ray,sea devil boats,sea devil boats reviews,sea devil kite,sea devil for sale,sea devils 1953 full movie,sea devils 1953 watch online,sea devil bubble gum simulator,devil's remnant sea of thieves,sea devil fishing boat,sea devil submarine,sea devil charters,devil sea history in urdu,devil sea movie,devil search,devil search app,devil search engine,sea devil 520,sea devil 620,sea devil centre console,sea devil point pleasant,sea devil point pleasant nj,sea devil short film,sea devil watch,cruisers sea devil 25,devil and deep blue sea expression,devil and deep blue sea imdb,devil and deep blue sea quote,devil and the deep sea uploady,devil deep blue sea george harrison,devil deep blue sea ukulele chords,devil fish and sea hare are,devil fish sea of thieves,devil fruit sea water,devil sea blue,devil sea fish,devil sea in hindi,devil sea meaning,devil sea urchin,devil sea urdu,devil seam,devil seance,devil season,devil season band,devil's cartographer sea of thieves,devil's cloth sea of thieves,devil's eye sea,devil's ridge quest sea of thieves,devil's ridge sea of thieves bug,devil's roar sea of thieves,devil's roar sea of thieves guide,devil's roar sea of thieves location,devil's roar sea of thieves map,devil's sea china,devil's sea coordinates,devil's sea cucumber,devil's sea gif,devil's sea google maps,devil's sea hong kong,devil's sea photo,devil's sea presentation,devil's sea reddit,devil's sea urchin,devil's sea urchin wiki,devil's sea urgent,devil's sea whip,devil's sea wikipedia,devil's shroud sea of thieves,devil's thirst quest sea of thieves,devils hole sea,devils plants sea of thieves,devils sea filter,dragonvale world sea devil egg,devils shroud sea of thieves quest,sea devil 2,sea devil (midway 1970),sea devil 2510,sea devil 2014,sea devil 5,sea devil 3210,sea devil 520 for sale,sea devil 520 centre console,sea devil 520 specs,sea devil 520 reviews,sea devil 620 for sale,sea devil 6.2,sea devil 620 review,sea devil 620 price,sea devil arcade game for sale,sea devil 95,sea devil boats facebook,sea devil boats 620,sea devil boats ulladulla,sea devil boats for sale,sea devil bookstore,sea devil book,sea devil by arthur gordon summary,sea devil by arthur gordon,sea devil codycross,sea devil chase,sea devil en espanol,sea devil crossword clue,sea devil fish codycross,sea devil ffxiv,sea devil fish recipe,sea devil fish eating,sea devil game,sea devil fish size,sea devil gumtree,sea devil game for sale,sea devil hulls,sea devil helicopter,sea devil manta ray,sea devil kraken,sea devil mascot,sea devil marine,sea devil midway,sea devil medallions,sea devil movie 2015,sea devil monkfish,sea devil plant,sea devil pdf,sea devil plot diagram,sea devil plot,sea devil questions,sea devil prezi,sea devil short story questions,sea devil quote,sea devil summary,sea devil ssn 664,sea devil uhr,sea devil summer,sea devil woman,sea devil underwater lights,sea devil wwii,sea devil wows,sea devils 1,sea devil zeilboot,sea devils 1953 cast,sea devils 1937,sea devils 1953 english subtitles,sea devils 1953 download,sea devils 1982,sea devils 1953 movie watch,sea devils episode 1,sea devils 5e,sea devils holton arms,sea devils hockey,sea devils washington dc,sea devils imdb,sea devils wilmington nc,sea devils water polo,sea of thieves devils roar quest,sea devils women's soccer,the devil's sea tattoo köln,the devil is sea,the sea devil eliza knight,the sea devil essay,the sea devil irony,the sea devil quizlet,"
    />
    <header>
    <h1 className="header-h1">The mystery of devil sea</h1>

    <div className="header-banner">
        <img src={myster} alt="Devil sea "/>
    </div>
   
    </header>
     
            <section className="content">
            <article>
            <h1>The Devil's Sea(The Dragon Triangle)</h1>
                        <h2>The Beginning</h2>
                        <p>
                           On September 8 ,1980 with about 150,000 Tonnes of iron a ship named DERBYSHIRE was moving ahead towards its destination.Being double the size of titanic and being the most reputed ship of its time no one thought what was about to happen to this gigantic ship.The next day on september 9,1980 under some mysterious conditions the ship along with all its crew members suddenly disappeared in the sea.It was the largest ship of the Britain at that time and also being handled by a much experienced crew members no one thought that this gigantic ship will disappear suddenly.So where did it went and why no traces of it cannot be found. 
                        </p>
                        <h2>Devil's Sea</h2>
                        <p>
                            After reading the above facts you could be probably thinking about the Bermuda Triangle but let me clear you that I'am not talking about the bermuda triangle but I am talking about the mystereious Devil's triangle which is located near Japan in the Japan sea.Everyone knows about the Bermuda triangle where many ships and plane disappeared suddenly but how many of you knew about this place.<br/>
                            To know about the ship's condition a large number of researchers who were expert in such paranormal activities were called of from the different parts of the earth to research on the missing ship and a government ship of Japan with all those researchers were sent to that area but the ship never returned.Where did the ship went?After that incident the government also banned all types of activities on that area and the place was declared as a danger zone.
                            
                        </p>
                        <h2>The investigations</h2>
                        <p>
                            Without going to that place just from the satellite image a research was performed that showed that like the Bermuda triangle it also formed a triangle.
                            <br/><br/><img src={triangle} alt="the triangle formed in the japan sea by the devils triangle." />
                            <br/><br/>But this was just a small fact.The satellite also noticed that the Bermuda triangle , the zone of silence in mexico ,the Great pyramids of Giza and the Devil's Triangle all lie in the same latitude and fits in a perfect straight line.Just think four of the world's biggest mystery lie in the same latitude.Is this just or coincidence or something else just imagine.
                            <br/><br/><img src={align} alt="alignment formed by the devil sea , the pyramids,the silence zone and the bermuda triangle" />
                            <br/><br/>Because of this alignment it is believed that there is some connection between these wo mysterious place on the earth ,the devil's sea and the devils triangle.
                        </p>
                        <h3>Theories</h3>
                        <p>
                            Many theories came out and explained the various reasons about this strange disappearances of the ships and planes.Let's discover them
                            <ul>
                                <li>A group of Japanese people think that there are some mysterious and paranormal forces inside this sea which swallows these ships and planes.According to them there is a dragon underwater here which destroys everything which coems here.Hmm soudns weird</li>
                                <li>Another group of people think that there is a portal inside this sea which swallows the ships and sends them to another world in the parallel universe.This type of hypothesis was also given in case of bermuda triangle.When science cannot answer our questions we have to believe this kind of theories only.</li>
                                <li>Another group of people says that there are ghosts and other paranormal things here which causes these phenomenon</li>
                              
                            </ul>
                            In 1987 researchers started to think about the possible things which are present in the sea below the point where ships and planes disappear.Many attempts were made but all of them failed and the researchers who went there died and never returned.But a group of 2 divers successfully completed the researched and came back.They did the research underwater and successfully completed it.They were searching for evidences along the border line of the devils triangle.While diving they noticed that the sea rocks had a proper shape as if it was carved by some human and put there in the sea because such pattens are not possible naturally as they have rough shapes.Just have a look at it.
                            <br/><br/><img src={s1} alt="Mysterious shapes of the rock in the sea bed near devil's sea " />
                            <hr/><img src={s2} alt="Mysterious shapes of the rock in the sea bed near devil's sea" />
                            <br/><br/>Researchers claim that these structures are made by some humans and dropped there but who as any writing about these structures was not found in any of the historical books of Japan.
                            There must be some connection between those mysterious stones and  the disappearing ships.
                        </p>
                        <h3>Actually what happens there</h3>
                        <p>According to some survivors who went there and came back from a distance noticed that after entering those places the compass will stop working and all electrical appliances will start to malfunction.Rough tides will soon start in the sea and weather suddenly changes a lot and lightning and thunders starts.Even people have claimed to see some mysterious items on the sky which looks like a UFO or something like that.Many people have claimed to have seen a whirlpool in the sea.<br/>
                            Many theories also claim that they see pirate ships in the sea with no crew members.Just imagine the situation there.Many claims that the phonomena of time dialation occurs there and people have experienced that.Time dialation is a scientifically proven phenomena and happens in real life also in places near to a blackholes.But why does this things happen in places like these and forces us to think out of science.
                        </p>
            </article>
            <div className="other">
                <div className="content1">
                  <Link to="/isro-aditya-l1/aditya-l1-isro-mission-to-conquer-the-sun">
                     <h4>
                        ISRO's mission to conquer the sun    
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/area-51/the-mystery-of-area-51-revealed">
                     <h4>
                        The mystery of area 51 revealed
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/amazon.com/unique-products-available-on-amazon">
                     <h4>
                        Unique products available on amazon.in
                      <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/cicada-3301/the-unsolved-mystery-of-cicada-3301">
                     <h4>
                        The unsolved mystery of cicada 3301
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="create-a-blog/an-indepth-guide-on-how-to-make-a-blog">
                     <h4>
                        How to create a free blog
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/truecaller-truth/truecaller-business-model-and -truth-revealed">
                     <h4>
                         The truth of truecaller app
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            
            
            <div className="other">
                <div className="content1">
                  <Link to="/time-travel/the-mystery-of-time-travel-revealed">
                     <h4>
                         The time travel mystery revealed
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/earn-money-online/ultimate-guide-to-earn-money-in-2019">
                     <h4>
                         Simple steps to earn money online
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/sun-facts/what-if-the-sun-disappears">
                     <h4>
                         What if the sun disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/fast-charger/fast-charging-technologies-explained">
                     <h4>
                        The principle of fast charging in smartphones
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/flat-earth/the-reality-of-flat-earth-society-debunked">
                     <h4>
                         The reality of flat earth society
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/smartphone-buying/ultimate-guide-to-purchase-smartphone">
                     <h4>
                         Ultimate guide to purchase a new smartphone
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/global-warming/innovative-technology-to-stop-global-warming">
                     <h4>
                        Innovation In Technologies to stop global warming
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/gps-working/indepth-guide-on-how-gps-works">
                     <h4>
                         Indepth guide on the working of GPS
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/pyramids-mystery/aliens-involvement-in-construction-of-pyramids">
                     <h4>
                        The alien involvement in construction of pyramids
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            
            <div className="other">
                <div className="content1">
                  <Link to="/laptop-buying/ultimate-laptop-buying-guide">
                     <h4>
                         The ultimate laptop buying guide             
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/moon-facts/what-if-moon-disappears">
                     <h4>
                         What if the moon disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 

                
         
</section> 
</Layout>
)}

export default IndexPage
